import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState, sessionStateKey } from './session.state';

export const selectSession = createFeatureSelector<SessionState>(sessionStateKey);
export const selectIsLoggedIn = createSelector(
	selectSession,
	(state: SessionState) => !!state?.loggedIn === true
);
export const selectUserRoles = createSelector(selectSession, (session) =>
	session.data.user.role.split(',')
);
export const selectIsAdmin = createSelector(selectUserRoles, (roles) => roles.includes('ADMIN'));
export const getAccountSetting = (setting: string, mappingFunction: (value: string) => any) =>
	createSelector(selectSession, (session) => mappingFunction(session.settings.account[setting]));
